module.exports = __webpack_public_path__ + "static/media/pesquisa1.acf337db.svg";